import React from 'react';
import loadable from '@loadable/component';

import FilterPanel from './FilterPanel';

const BotFilters = loadable(() => import('../BotFilters'), {
    resolveComponent: (component) => component.BotFilters,
});

import withStickyScrollNewLayout from '../../hoc/withStickyScrollNewLayout';

const EnhancedFilterPanel = withStickyScrollNewLayout(FilterPanel);

export const FilterPanelDesktop = (props) => {
    if (props.isBotRequest) {
        return <BotFilters slug={props.locationSlug} />;
    }

    const handleFilterChange = (...args) => {
        props.onFilterChange(...args);
        props.handleDrawerSelect('');

        // Scroll back to top of screen, otherwise
        // it looks strange
        window.scrollTo(0, 0);
    };

    return (
        <EnhancedFilterPanel
            {...props}
            style={{ maxWidth: '320px' }}
            onFilterChange={handleFilterChange}
        />
    );
};

export default FilterPanelDesktop;
